import { render } from "./BaseDataTableBtn.vue?vue&type=template&id=1b878785"
import script from "./BaseDataTableBtn.vue?vue&type=script&lang=js"
export * from "./BaseDataTableBtn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__